import {
	disablePageScroll,
	enablePageScroll,
} from "scroll-lock";
import { throttle } from "../helpers/throttle";

const initNavigation = () => {
	const customCursor = document.querySelector('.custom-cursor');
	const pageTransition = document.querySelector('.page-transition');
	const hamburger = document.querySelector('.header__hamburger');
	const overlay = document.querySelector('.header-overlay');
	const overlayBox = document.querySelector('.header-overlay__box');
	const overlayBlob = document.querySelector('.header-overlay__blob');
	const darkmode = document.querySelector('.header__darkmode');
	const disrupter = document.querySelector('.header-disrupter');
	const bg = document.querySelector('.header__bg');

	// Resizes bg element to original size or fill out screen depending if isActive
	const resizeBg = (isActive = true) => {
		let scale = 1;
		if (isActive) {
			// Calculate approximate scale value for bg element to fill the screen
			const wWidth = window.innerWidth;
			const wHeight = window.innerHeight;
			const wDiagonal = Math.sqrt(wWidth * wWidth + wHeight * wHeight);
			const bgDiameter = bg.offsetWidth;
			scale = 2 * (wDiagonal / bgDiameter);
		}
		bg.style.transform = `scale(${scale})`;
	};

	const positionBlob = () => {
		let centerX, centerY, size;
		if (window.innerWidth >= 1024) {
			centerX = overlayBox.offsetLeft + overlayBox.offsetWidth / 2;
			centerY = overlayBox.offsetTop + overlayBox.offsetHeight / 2 + 50;
			size = overlayBox.offsetHeight * 1.3;
		} else {
			centerX = overlay.offsetWidth;
			centerY = overlay.offsetHeight / 2;
			size = overlay.offsetHeight * 0.8;
		}
		overlayBlob.style.transform = `translate(calc(${centerX}px - 50%), calc(${centerY}px - 50%))`;
		overlayBlob.style.height = `${size}px`;
		overlayBlob.style.width = `${size}px`;
	}

	const resizeEventHandler = () => {
		resizeBg(true);
		positionBlob();
	};

	const throttledResizeEventHandler = throttle(100, resizeEventHandler);

	const openOverlay = (showAnimation = true) => {
		disablePageScroll();
		window.addEventListener('resize', throttledResizeEventHandler, { passive: true });
		setTimeout(() => {
			jQuery(overlay).fadeIn(showAnimation ? 250 : 0);
			positionBlob();
		}, showAnimation ? 250 : 0);
		hamburger.setAttribute('aria-expanded', 'true');
		hamburger.classList.add('header__hamburger--active');
		darkmode.classList.add('header__darkmode--header-overlay-open');
		customCursor.classList.add('custom-cursor--header-overlay-open');
		pageTransition.classList.add('page-transition--header-overlay-open');
		if (disrupter) disrupter.classList.add('header-disrupter--header-overlay-open');
		resizeBg(true);
		document.dispatchEvent(new Event('headerOverlayOpened'));
	}

	const closeOverlay = (showAnimation = true) => {
		enablePageScroll();
		window.removeEventListener('resize', throttledResizeEventHandler);
		jQuery(overlay).fadeOut(showAnimation ? 250 : 0);
		hamburger.setAttribute('aria-expanded', 'false');
		hamburger.classList.remove('header__hamburger--active');
		darkmode.classList.remove('header__darkmode--header-overlay-open');
		customCursor.classList.remove('custom-cursor--header-overlay-open');
		pageTransition.classList.remove('page-transition--header-overlay-open');
		if (disrupter) disrupter.classList.remove('header-disrupter--header-overlay-open');
		resizeBg(false);
		setTimeout(() => {
			document.dispatchEvent(new Event('headerOverlayClosed'));
		}, showAnimation ? 250 : 0);
	}

	hamburger.addEventListener('click', throttle(500, () => {
		const isActive = hamburger.classList.contains('header__hamburger--active');
		if (isActive) {
			closeOverlay();
		} else {
			openOverlay();
		}
	}));

	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape') {
			const isActive = hamburger.classList.contains('header__hamburger--active');
			if (isActive) {
				closeOverlay();
			}
		}
	});

	window.openOverlay = openOverlay;
	window.closeOverlay = closeOverlay;
};

document.addEventListener("DOMContentLoaded", initNavigation);
